<template>
    <AppLayout>
        <div class="container pt-5">

            <!-- Welcome Back Card -->
            <div class="row">
                <div class="col-md-12">
                    <div class="card" id="welcome-card">
                        <div class="card-body py-4">
                            <div class="left">
                                <!-- Show different content based on authentication status -->
                                <h2 class="card-title" v-if="isAuthenticated">
                                    Welcome Back! {{ user.first_name }} {{ user.last_name }}
                                </h2>
                                <h2 class="card-title" v-else>
                                    Welcome Guest
                                </h2>
                                <p class="card-text subtitle">This is your dashboard where you can manage your activities.</p>
                            </div>
                            <div class="avatar">
                                {{ user ? user.first_name.charAt(0) + user.last_name.charAt(0) : 'GU' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- My Membership details cards  -->
            <div class="row mt-4" id="membership_cards">

                <!-- Membership Status -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-info"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Membership Status </span>
                                <h6 class="bold text-primary">{{ membership?.formatted_status || 'No Membership' }}</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Days Until renewal -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-alarm"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Days Until Renewal</span>

                                <h6 class="bold text-primary">{{ formatDaysUntilRenewal(membership?.days_until_renewal) }}</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Certificate Status -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-patch-check"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Certificate Status</span>
                                <h6 class="bold text-primary">{{ certificate?.formatted_status || 'No Certificate' }}</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Membership Type -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-person"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Membership Type</span>
                                <h6 class="bold text-primary">{{ membership?.formatted_membership_type || 'N/A' }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Actions -->
            <div class="row mt-4">

                <!-- Membership details -->
                <div class="col-md-8">
                    <div class="card h-100">
                        <div class="card-body">
                            <h5 class="bold">Membership Details</h5>

                            <div class="row pt-4">
                                <!-- Membership Number -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Membership Number</span>
                                    <h6 class="bold">{{ membership?.membership_number || 'N/A' }}</h6>
                                </div>

                                <!-- Type -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Membership Type</span>
                                    <h6 class="bold">{{ membership?.membership_type || 'N/A' }}</h6>
                                </div>

                                <!-- Start date -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Start Date</span>
                                    <h6 class="bold">{{ membership?.start_date || 'N/A' }}</h6>
                                </div>

                                <!-- Expiry Date -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Expiry Date</span>
                                    <h6 class="bold">{{ membership?.expiry_date || 'N/A' }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- My certificate -->
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="bold">My Certificate</h5>

                            <div class="inner text-center">
                                <div class="avatar mb-3 bg-success">{{ certificate?.certificate_number.charAt(0) || 'N/A' }}</div>
                                <span class="subtitle">Certificate Number</span>
                                <h6 class="bold mb-3">{{ certificate?.certificate_number || 'No Certificate' }}</h6>
                                <p class="subtitle mt-2 display-6">Issued on: {{ certificate?.issue_date || 'N/A' }} <br> Valid until: {{ certificate?.expiry_date || 'N/A' }}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Learning & Professional Development -->
            <div class="row mt-4 d-none">
                <!-- Course Progress -->
                <div class="col-md-6 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Learning Progress</h5>
                                <a href="#" class="btn btn-sm btn-outline-primary">View All</a>
                            </div>

                            <!-- Current Courses -->
                            <div class="course-item mb-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">Cybersecurity Fundamentals</h6>
                                    <span class="badge bg-primary">75%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-primary" style="width: 75%"></div>
                                </div>
                                <small class="text-muted">3 of 4 modules completed</small>
                            </div>

                            <div class="course-item mb-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">GDPR Compliance</h6>
                                    <span class="badge bg-success">100%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-success" style="width: 100%"></div>
                                </div>
                                <small class="text-muted">Certificate earned</small>
                            </div>

                            <div class="course-item">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">Risk Management</h6>
                                    <span class="badge bg-warning">25%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-warning" style="width: 25%"></div>
                                </div>
                                <small class="text-muted">Started 2 days ago</small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CPD & Professional Development -->
                <div class="col-md-6 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Professional Development</h5>
                                <a href="#" class="btn btn-sm btn-outline-success">Track CPD</a>
                            </div>

                            <!-- CPD Hours -->
                            <div class="row text-center mb-4">
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-primary mb-0">28</h4>
                                        <small class="text-muted">CPD Hours</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-success mb-0">5</h4>
                                        <small class="text-muted">Certificates</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-info mb-0">12</h4>
                                        <small class="text-muted">Badges</small>
                                    </div>
                                </div>
                            </div>

                            <!-- Recent Achievements -->
                            <h6 class="bold mb-3">Recent Achievements</h6>
                            <div class="achievement-item mb-2">
                                <div class="d-flex align-items-center">
                                    <div class="badge bg-warning rounded-circle me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                        <i class="bi bi-award"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0">GDPR Expert</h6>
                                        <small class="text-muted">Earned 2 days ago</small>
                                    </div>
                                </div>
                            </div>
                            <div class="achievement-item">
                                <div class="d-flex align-items-center">
                                    <div class="badge bg-info rounded-circle me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                        <i class="bi bi-shield-check"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0">Security Champion</h6>
                                        <small class="text-muted">Earned 1 week ago</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Community & Quick Actions -->
            <div class="row mt-4">
                <!-- Community Activity -->
                <div class="col-md-12 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Community & Events</h5>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <h6 class="bold mb-3">Upcoming Events</h6>
                                    <div v-if="upcomingEvents && upcomingEvents.length > 0">
                                        <div v-for="event in upcomingEvents" :key="event.id" class="event-item mb-4">
                                            <div class="d-flex">
                                                <div class="event-date me-3">
                                                    <div class="text-center text-white rounded p-2" :class="event.is_featured ? 'bg-primary' : 'bg-success'">
                                                        <div style="font-size: 0.8rem;">{{ event.month }}</div>
                                                        <div style="font-weight: bold;">{{ event.day }}</div>
                                                        <div v-if="event.is_featured" class="featured-badge">
                                                            <i class="bi bi-star-fill"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="event-details">
                                                    <h6 class="mb-1 event-title">
                                                        {{ event.title }}
                                                        <span v-if="event.is_online" class="badge bg-info ms-2">Online</span>
                                                    </h6>
                                                    <div class="event-info mb-1">
                                                        <i class="bi bi-clock me-1"></i>
                                                        <small class="text-muted">{{ event.time }}</small>
                                                        <i class="bi bi-geo-alt ms-3 me-1" v-if="!event.is_online"></i>
                                                        <small class="text-muted" v-if="!event.is_online">{{ event.location }}</small>
                                                        <i class="bi bi-link-45deg ms-3 me-1" v-if="event.is_online && event.online_url"></i>
                                                        <small class="text-muted" v-if="event.is_online && event.online_url">
                                                            <a :href="event.online_url" target="_blank">Join Link</a>
                                                        </small>
                                                    </div>
                                                    <p class="event-description mb-0" v-if="event.description">
                                                        {{ truncateDescription(event.description, 100) }}
                                                        <a href="#" class="text-primary ms-1" @click.prevent="toggleDescription(event)" v-if="event.description.length > 100">
                                                            {{ event.showFullDescription ? 'Show less' : 'Read more' }}
                                                        </a>
                                                    </p>
                                                    <p class="event-full-description" v-if="event.showFullDescription">
                                                        {{ event.description }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center mt-3 d-none">
                                            <a href="#" class="btn btn-sm btn-outline-primary">View All Events</a>
                                        </div>
                                    </div>
                                    <div v-else class="alert alert-info">
                                        No upcoming events at this time.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Quick Actions -->
                <div class="col-md-4 mb-4 d-none">
                    <div class="card h-100">
                        <div class="card-body">
                            <h5 class="bold mb-3">Quick Actions</h5>

                            <div class="d-grid gap-2">
                                <button class="btn btn-primary">
                                    <i class="bi bi-book me-2"></i>Continue Learning
                                </button>
                                <button class="btn btn-success">
                                    <i class="bi bi-clipboard-check me-2"></i>Take Practice Test
                                </button>
                                <button class="btn btn-info">
                                    <i class="bi bi-briefcase me-2"></i>Browse Jobs
                                </button>
                                <button class="btn btn-warning">
                                    <i class="bi bi-people me-2"></i>Find Mentor
                                </button>
                                <button class="btn btn-outline-primary">
                                    <i class="bi bi-calendar-event me-2"></i>Book Session
                                </button>
                                <button class="btn btn-outline-secondary">
                                    <i class="bi bi-download me-2"></i>Resources
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Compliance Dashboard -->
            <div class="row mt-4 d-none">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Compliance Dashboard</h5>
                                <a href="#" class="btn btn-sm btn-outline-danger">View Reports</a>
                            </div>

                            <div class="row">
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-success text-white mb-2">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <h6 class="mb-1">GDPR</h6>
                                        <small class="text-success">Compliant</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-warning text-white mb-2">
                                            <i class="bi bi-exclamation-lg"></i>
                                        </div>
                                        <h6 class="mb-1">POPIA</h6>
                                        <small class="text-warning">Needs Review</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-success text-white mb-2">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <h6 class="mb-1">ISO/IEC 27001</h6>
                                        <small class="text-success">Certified</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-info text-white mb-2">
                                            <i class="bi bi-clock"></i>
                                        </div>
                                        <h6 class="mb-1">NIST</h6>
                                        <small class="text-info">In Progress</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>



<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { computed, toRaw } from 'vue';
import { usePage } from '@inertiajs/vue3';

// Get page props
const page = usePage();

// Define props
const props = defineProps({
    membership: Object,
    certificate: Object,
    upcomingEvents: Array,
});

// Check if user is authenticated
const isAuthenticated = computed(() => {
    return !!page.props.auth.user;
});

// Get authenticated user
const user = computed(() => {
    return page.props.auth.user;
});

// Get membership and certificate data from page props
const membership = computed(() => {
    return page.props.membership;
});

const certificate = computed(() => {
    return page.props.certificate;
});

// Helper function to format days until renewal
const formatDaysUntilRenewal = (days) => {
    if (days === null || days === undefined) return 'N/A';

    const numDays = Math.max(0, Math.floor(days));

    if (numDays === 0) return 'Expires Today';
    if (numDays === 1) return '1 day';
    return `${numDays} days`;
};

// Initialize description toggle properties for each event
if (props.upcomingEvents) {
    props.upcomingEvents.forEach(event => {
        event.showFullDescription = false;
    });
}

// Function to truncate event descriptions
const truncateDescription = (text, length) => {
    if (!text) return '';
    return text.length > length ? text.substring(0, length) + '...' : text;
};

// Function to toggle showing full description
const toggleDescription = (event) => {
    event.showFullDescription = !event.showFullDescription;
};

console.log(toRaw(user.value)); // Debug: Log user object
console.log('Membership data:', toRaw(membership.value)); // Debug: Log membership data
console.log('Certificate data:', toRaw(certificate.value)); // Debug: Log certificate data
console.log('Upcoming Events:', toRaw(props.upcomingEvents)); // Debug: Log upcoming events

</script>






<style scoped>
/* Bootstrap Primary Color Override */
:deep(.text-primary) {
    color: #1e9579 !important;
}

:deep(.bg-primary) {
    background-color: #1e9579 !important;
}

:deep(.btn-primary) {
    background-color: #1e9579;
    border-color: #1e9579;
}

:deep(.btn-primary:hover) {
    background-color: #176f5e;
    border-color: #176f5e;
}

:deep(.progress-bar.bg-primary) {
    background: linear-gradient(90deg, #1e9579 0%, #2dd4bf 100%) !important;
}

:deep(.badge.bg-primary) {
    background-color: #1e9579 !important;
}

/* Course Progress Components */
.course-item {
    padding: 0.75rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.course-item:last-child {
    border-bottom: none;
}

.progress {
    border-radius: 10px;
    overflow: hidden;
}

.progress-bar {
    border-radius: 10px;
}

/* CPD Statistics */
.cpd-stat h4 {
    font-weight: 700;
    font-size: 1.8rem;
}

/* Achievement Items */
.achievement-item {
    padding: 0.5rem 0;
}

.achievement-item:last-child {
    border-bottom: none;
}

/* Event Components */
.event-item {
    padding: 0.8rem 0;
    border-bottom: 1px solid #f5f5f5;
    position: relative;
}

.event-item:last-child {
    border-bottom: none;
}

.event-item:hover {
    background-color: #f9f9f9;
    border-radius: 8px;
}

.event-date>div {
    width: 56px;
    height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.event-title {
    font-weight: 600;
    font-size: 1rem;
    color: #1e3a8a;
    display: flex;
    align-items: center;
}

.event-info {
    font-size: 0.85rem;
    display: flex;
    align-items: center;
}

.event-description {
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.5rem;
    line-height: 1.5;
}

.event-full-description {
    font-size: 0.85rem;
    color: #666;
    margin-top: 0.5rem;
    padding: 0.5rem;
    background: #f9f9f9;
    border-radius: 4px;
    border-left: 3px solid #1e9579;
}

.featured-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ffb400;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Forum Items */
.forum-item {
    padding: 0.5rem 0;
    border-bottom: 1px solid #f5f5f5;
}

.forum-item:last-child {
    border-bottom: none;
}

.forum-item h6 {
    font-size: 0.9rem;
    color: #2c3e50;
}

/* Compliance Dashboard */
.compliance-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-size: 1.5rem;
}

.compliance-item {
    padding: 1rem;
}

/* General Styling */
.bold {
    font-weight: 600;
}

.subtitle {
    color: #6c757d;
    font-size: 0.9rem;
}

.card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
}

/* Stats Cards */
.stats_card {
    border-radius: 12px;
    transition: all 0.3s ease;
}

.stats_card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.stats_card .card-body {
    display: flex;
    align-items: center;
    padding: 1.25rem;
}

.stats_card .icon {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    font-size: 1.25rem;
}

.stats_card .details {
    flex: 1;
}

.stats_card .details .subtitle {
    display: block;
    font-size: 0.8rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
}

.stats_card .details h6 {
    margin-bottom: 0;
    font-weight: 700;
}

/* Welcome Card */
#welcome-card {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    border: none;
    border-radius: 16px;
}

#welcome-card .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem;
}

#welcome-card .left h2 {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

#welcome-card .subtitle {
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 0;
}

.avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
}

/* Button Improvements */
.btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Responsive Design */
@media (max-width: 768px) {
    #welcome-card .card-body {
        flex-direction: column;
        text-align: center;
    }

    .avatar {
        margin-top: 1rem;
    }

    .stats_card .card-body {
        flex-direction: column;
        text-align: center;
    }

    .stats_card .icon {
        margin-right: 0;
        margin-bottom: 0.75rem;
    }

    .event-date>div {
        width: 40px;
        height: 40px;
    }

    .compliance-circle {
        width: 50px;
        height: 50px;
        font-size: 1.2rem;
    }
}
</style>
